import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
  FaUserCheck,
  FaIdCard,
  FaExternalLinkAlt,
  FaListAlt,
  FaCheckCircle,
  FaFileUpload,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import { BadgeCheck, FileText } from "lucide-react";

const KvbBank = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };

  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }

  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  const currentCards = CreditCardData.cards
    ?.filter((card) => card.title?.toLowerCase().includes("kvb bank"))
    .slice(indexOfFirstCard, indexOfLastCard);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const faqs = [
    {
      question:
        "Can I apply for a KVB credit card if I don’t have a KVB bank account?",
      answer:
        "Yes, you can. However, having a prior banking relationship with KVB may expedite your application process.",
    },
    {
      question: "Do KVB credit cards support international transactions?",
      answer:
        "Yes. Most KVB credit cards are internationally valid and can be used at global merchant outlets and online platforms.",
    },
    {
      question: "What is the billing cycle for KVB credit cards?",
      answer:
        "The billing cycle is typically 30 days, with a grace period of up to 50 days for interest-free repayments, depending on the card type.",
    },
    {
      question: "Are there any reward programs for KVB credit cardholders?",
      answer:
        "Yes. KVB offers reward points on eligible transactions, which can be redeemed for travel, shopping, and lifestyle rewards through their rewards portal.",
    },
    {
      question: "How do I repay my KVB credit card bill?",
      answer:
        "Payments can be made via net banking, auto-debit from KVB accounts, NEFT, or UPI from any bank account.",
    },
  ];

  const steps = [
    {
      icon: <FaListAlt className="h-6 w-6 text-teal-500" />,
      title: "Explore & Compare with TheFinMaster",
      description:
        "Visit TheFinMaster to browse through our curated range of Karur Vysya Bank credit cards. Each card page includes detailed descriptions of benefits, charges, usage categories, and suitable profiles, helping you make an informed choice.",
    },
    {
      icon: <FaCheckCircle className="h-6 w-6 text-orange-500" />,
      title: "Check Your Eligibility",
      description:
        "Go through our eligibility checklist to ensure you meet the age, income, credit score, and documentation requirements.",
    },
    {
      icon: <FaFileUpload className="h-6 w-6 text-green-500" />,
      title: "Gather Required Documents",
      description:
        "Collect all necessary documents for ID, address, and income proof. Ensure they're updated and legible to avoid delays in processing.",
    },
    {
      icon: <FaExternalLinkAlt className="h-6 w-6 text-purple-600" />,
      title: "Apply via Official Bank Website",
      description:
        "Once you’ve selected the ideal KVB credit card on TheFinMaster, click on Apply Now to get redirected to Karur Vysya Bank’s official credit card application portal for submission.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          Get Karur Vysya Bank Credit Card 2024 - Compare & Apply Online at
          TheFinmaster
        </title>
        <meta
          name="description"
          content="Karur Vysya Bank Credit Cards - Check all types of KVB credit cards list & their benefits to select the right card for you. Apply for top & best KVB credit card now. | TheFinmaster"
        />
        <meta
          name="keywords"
          content="karur vysya bank credit card, kvb credit card apply, karur vysya bank credit card benefits, kvb credit card eligibility, kvb credit card rewards"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/karur-vysya-bank/credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex flex-col items-center ">
        <div className="w-full flex flex-col items-center ">
          <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
            <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
              Credit Card
            </h1>
            <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
              Experience financial freedom and flexibility with our credit card
              options.
            </p>
          </div>
        </div>
        <div className="flex justify-center items-center  p-4 ">
          <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Smart Credit Solutions with Regional Expertise and National Reach
            </h2>

            <p className="text-gray-600 leading-relaxed mt-3">
              Karur Vysya Bank (KVB), with its legacy of over 100 years, offers
              credit cards that combine modern financial convenience with the
              personalized touch of a traditional Indian bank. Designed for
              salaried professionals, self-employed individuals, and premium
              users alike, KVB credit cards bring value through EMV chip
              security, flexible billing cycles, attractive rewards, and wide
              acceptance across domestic and international merchants.
            </p>
          </div>
        </div>
        <h1 className="text-center text-2xl md:text-3xl font-bold text-gray-800 my-10">
          Featured Credit Cards
        </h1>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                      key={index}
                      cardDetails={item}
                      Card_features={item?.Card_features}
                      fees={item?.fees}
                      cardName={item?.title}
                      cardImage={item?.image}
                      rating={item?.rating}
                      category={item?.category}
                      status={item?.status}
                      bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

             <div className="w-full relative ">
                     <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
                       {/* <div className="w-[70%] mx-auto">
                                                                    <h2 className="text-center font-medium pt-5 text-lg">
                                                                      <span className="font-semibold text-white">816 people</span>{" "}
                                                                      are on call with our advisors right now
                                                                    </h2>
                                                                  </div> */}
                       <div className="w-full mx-auto">
                         <Link
                           to="https://play.google.com/store/apps/details?id=com.fatakpay&pcampaignid=web_share"
                           target="_blank"
                           rel="noopener noreferrer"
                         >
                           <div className="w-[80%] mx-auto ">
                             <img src="/assets/ftak.jpg" alt="Advertisement" />
                           </div>
                         </Link>
                         <div className="bg-white">
                           {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                                                        Know your advisor
                                                                      </h3> */}
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>

 

        <div className="w-full px-2 py-2 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
          <div className="max-w-6xl mx-auto grid gap-10">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-8 h-8 text-sky-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Eligibility Criteria to Apply for KVB Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Age Requirement
                  </span>
                  <span>
                    Applicants must be between 21 and 65 years old. For add-on
                    cards, the minimum age requirement is 18 years.
                  </span>
                </div>

                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Income
                  </span>
                  <span>
                    Salaried applicants should have a net monthly income of
                    ₹25,000 or above. For self-employed applicants, annual income
                    as per ITR should be at least ₹3 lakhs.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Credit Score
                  </span>
                  <span>
                    A CIBIL score of 700 or higher is recommended for a smooth
                    approval. A strong repayment history boosts your chances of
                    selection.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Employment Stability
                  </span>
                  <span>
                    Salaried individuals must have been employed for at least 1
                    year. Self-employed individuals should have been in business
                    for 2+ years, with proper documentation.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Existing Relationship with KVB
                  </span>
                  <span>
                    Preference is often given to applicants who hold a savings or
                    salary account with Karur Vysya Bank.
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <BadgeCheck className="w-8 h-8 text-emerald-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Documents Required to Apply for KVB Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Identity
                  </span>
                  <span>
                    Documents such as Aadhaar Card, Passport, Voter ID, or
                    Driving License are accepted as valid identity proofs.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Address
                  </span>
                  <span>
                    Recent utility bills, passport, Aadhaar, or rental agreements
                    are required for address verification.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Income Proof
                  </span>
                  <span>
                    Salaried: Last 3 months’ salary slips and Form 16.
                    Self-employed: Latest ITRs, bank statements, or audited P&L
                    account.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    PAN Card
                  </span>
                  <span>
                    Mandatory as per RBI regulations for credit card
                    applications and financial compliance.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Recent Photograph
                  </span>
                  <span>
                    One passport-sized color photo is required along with the
                    application.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          How to Apply for KVB Credit Card
        </h2>
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default KvbBank;